module.exports = __webpack_public_path__ + "static/media/beach2383.3de3c0df.jpg";